import React from 'react'
import styled from 'styled-components'

interface Props {
  children: React.ReactNode
  className?: string
}

const ErrorMessageText = styled.p`
  position: absolute;
  top: 101%;
  right: 0;
  left: 0;
  margin: 0;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.global.colors.red};
`

export const ErrorMessage = ({ children, className }: Props) => {
  return <ErrorMessageText className={className}>{children}</ErrorMessageText>
}
